
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns6e923d05558c99524300fdeb0f5f0f07en from './en.yaml'
            i18n.addResourceBundle('en', '6e923d05558c99524300fdeb0f5f0f07', flattenObject(ns6e923d05558c99524300fdeb0f5f0f07en), true, true);
        
        export default '6e923d05558c99524300fdeb0f5f0f07';
    